import { useTheme as useElementalTheme } from '@fortum/elemental-ui'

import type { Theme } from '@/style/theme'

export const useTheme = () => {
  const theme = useElementalTheme()
  return theme as Theme
}
